import React from 'react';
import { IMember } from 'types';
import { useTranslation } from 'react-i18next';
import { formatCPF } from '../../../utils/formatCPF';

const ProfileDesktop = ({ created, birthdate, email, cpf }: Partial<IMember>) => {
  const { t } = useTranslation('corpClubProfile');

  return (
    <div className="body-profile-data-container">
      <div className="body-profile-data-container-db">
        <div className="body-profile-data-container-db-date">
          <span>{t('included_date_title')}</span>
          <p>{created}</p>
        </div>
        <div className="body-profile-data-container-db-birthday">
          <span>{t('birthday_title')}</span>
          <p>{birthdate}</p>
        </div>
      </div>
      <div className="body-profile-data-container-ec">
        <div className="body-profile-data-container-ec-email">
          <span>{t('email_title')}</span>
          <p>{email}</p>
        </div>
        <div className="body-profile-data-container-ec-cpf">
          <span>{t('cpf_title')}</span>
          <p>{formatCPF(cpf || '')}</p>
        </div>
      </div>
    </div>
  );
};

export default ProfileDesktop;
